import { IconProps } from '@/root/shared-types/ui/ui-types'
import React, { FC } from 'react'
import Icon from '@/root/ui/shared/Icon'

export const PassengerIconCyan: FC<IconProps> = ({ width = 12, height = 22, ...rest }) => (
  <Icon type="PassengerCyan" width={width} height={height} alt="PassengerIconCyan" {...rest} />
)
